// 域名(跳转地址)
export const SET_JUMPLINK = 'SET_JUMPLINK'
// 用户信息
export const SET_USER_INFO = 'SET_USER_INFO'
// 个人中心信息
export const SET_OWNER_INFO = 'SET_OWNER_INFO'
// 修改账户信息头像
export const SET_OWNER = 'SET_OWNER'
// 主题图
export const SET_THEMEIMG = 'SET_THEMEIMG'
// 登录页配置
export const SET_LOGIN_CONFIG = 'SET_LOGIN_CONFIG'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js